import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { AuthShell, Field } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim(), origin_url: window.location.origin });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell title="Forgot your password?" subtitle="Happens to the best of us.">
      {done ? (
        <div className="space-y-5" data-testid="forgot-success">
          <p className="text-[var(--ink-secondary)]">
            If that email's in our system, we just sent a reset link. Check your inbox.
          </p>
          <Link to="/login" className="btn-ghost inline-block" data-testid="forgot-back-link">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-form">
          <Field label="Email">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              data-testid="forgot-email"
              className="w-full bg-transparent border-b border-[var(--line)] focus:border-[var(--brand)] outline-none py-2 text-base"
            />
          </Field>
          {error && <p className="text-sm text-[var(--err)]" data-testid="forgot-error">{error}</p>}
          <button type="submit" disabled={submitting} className="btn-brand w-full disabled:opacity-60" data-testid="forgot-submit">
            {submitting ? "Sending…" : "Send reset link"}
          </button>
          <div className="text-center text-sm">
            <Link to="/login" className="text-[var(--ink-secondary)] hover:text-[var(--ink-primary)]" data-testid="forgot-login-link">
              Back to sign in
            </Link>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
